import React from 'react';
import { Table } from 'react-bootstrap';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Input from '../components/forms/Input';
import InstallationServiceSearchButtonAndPdfButton from './InstallationServiceSearchButtonAndPdfButton';

class InstallationServiceForm extends React.Component {
  render() {
    const {
      translate,
      shipmentNumber,
      shipmentType,
      consignorName,
      customerName,
      companyName,
      customerAddress,
      customerPostcode,
      customerCity,
      customerPhone,
      customerPhone2,
      customerEmail,
      invoiceReference,
      invoiceReference2,
      onHandleChange,
      onDataConfirmation,
      shipmentRequestLoading,
      isEditState,
      pdfDownloadHandler,
      installationLastStatus,
      isAdmin,
      pdfName,
    } = this.props;
    return (
      <div className="table-top-padding">
        <Table bordered>
          <thead className="table-head">
            <tr>
              <th>
                {translate('service_installation.owner_user_title')}
                {' '}
                {shipmentType}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="table-body-text-padding">
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="shipmentNumber">
                        {translate('service_installation.jjfi_code')}
                        {' '}
                        *
                      </label>
                      <Input
                        type="text"
                        value={shipmentNumber}
                        className="shipment-text-bar-input"
                        id="shipmentNumber"
                        name="shipmentNumber"
                        onChange={onHandleChange}
                        onKeyPress={onHandleChange}
                        required
                        disabled={isEditState} />
                      <InstallationServiceSearchButtonAndPdfButton dataConfirmation={onDataConfirmation}
                                                                   shipmentRequestLoading={shipmentRequestLoading}
                                                                   shipmentNumber={shipmentNumber}
                                                                   isEditState={isEditState}
                                                                   pdfName={pdfName}
                                                                   isAdmin={isAdmin}
                                                                   installationLastStatus={installationLastStatus}
                                                                   downloadPDF={pdfDownloadHandler} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="consignorName">
                        {translate('service_installation.sender')}
                        {' '}
                        *
                      </label>
                      <Input
                        type="text"
                        value={consignorName}
                        className="shipment-text-bar-input"
                        id="consignorName"
                        name="consignorName"
                        onChange={onHandleChange}
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerName">
                        {translate('service_installation.name')}
                        {' '}
                        *
                      </label>
                      <Input
                        type="text"
                        value={customerName}
                        className="shipment-text-bar-input"
                        id="customerName"
                        name="customerName"
                        onChange={onHandleChange}
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="companyName">
                        {translate('service_installation.company')}
                      </label>
                      <Input
                        type="text"
                        value={companyName}
                        className="shipment-text-bar-input"
                        id="companyName"
                        name="companyName"
                        onChange={onHandleChange} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerAddress">
                        {translate('service_installation.address')}
                        {' '}
                        *
                      </label>
                      <Input
                        type="text"
                        value={customerAddress}
                        className="shipment-text-bar-input"
                        id="customerAddress"
                        name="customerAddress"
                        onChange={onHandleChange}
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerPostcode">
                        {translate('service_installation.postal_code')}
                        {' '}
                        *
                      </label>
                      <Input
                        type="text"
                        value={customerPostcode}
                        className="shipment-text-bar-input"
                        id="customerPostcode"
                        name="customerPostcode"
                        onChange={onHandleChange}
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerCity">
                        {translate('service_installation.city')}
                        {' '}
                        *
                      </label>
                      <Input
                        type="text"
                        value={customerCity}
                        className="shipment-text-bar-input"
                        id="customerCity"
                        name="customerCity"
                        onChange={onHandleChange}
                        required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerPhone">
                        {translate('service_installation.customer_phone')}
                      </label>
                      <Input
                        type="text"
                        value={customerPhone}
                        className="shipment-text-bar-input"
                        id="customerPhone"
                        name="customerPhone"
                        onChange={onHandleChange} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerPhone2">
                        {translate('service_installation.customer_phone2')}
                      </label>
                      <Input
                        type="text"
                        value={customerPhone2}
                        className="shipment-text-bar-input"
                        id="customerPhone2"
                        name="customerPhone2"
                        onChange={onHandleChange} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="customerEmail">
                        {translate('service_installation.customer_email')}
                      </label>
                      <Input
                        type="text"
                        value={customerEmail}
                        className="shipment-text-bar-input"
                        id="customerEmail"
                        name="customerEmail"
                        onChange={onHandleChange} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="invoiceReference">
                        {translate('service_installation.invoice_reference')}
                      </label>
                      <Input
                        type="text"
                        value={invoiceReference}
                        className="shipment-text-bar-input"
                        id="invoiceReference"
                        name="invoiceReference"
                        onChange={onHandleChange} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-div form-group">
                      <label className="shipment-label"
                             htmlFor="invoiceReference2">
                        {translate('service_installation.invoice')}
                      </label>
                      <Input
                        type="text"
                        value={invoiceReference2}
                        className="shipment-text-bar-input"
                        id="invoiceReference2"
                        name="invoiceReference2"
                        onChange={onHandleChange} />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const session = state.session.session || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    currentLanguage: (activeLanguage && activeLanguage.code) || 'fi',
    translate: getTranslate(locale),
    session,
  };
};

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceForm);
